import {defineRouting} from 'next-intl/routing';
import {LOCALE_CODES, LOCALES} from '#i18n/constants.ts';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: LOCALES.map(o => o.code),
  // If you want to use no prefix for the default locale
  localePrefix: 'as-needed',
  // If a user changes the locale to a value that doesn't match
  // the accept-language header, next-intl will set a session cookie
  // called NEXT_LOCALE that contains the most recently detected locale.
  // This is used to remember the user's locale preference for subsequent requests.
  localeCookie: true,
  // If you want to rely entirely on the URL to resolve the locale,
  // you can set the localeDetection property to false. This will
  // disable locale detection based on the accept-language header
  // and a potentially existing cookie value from a previous visit.
  localeDetection: false,
  // Used when no locale matches
  defaultLocale: LOCALE_CODES.NO
});
